'use strict';

module.exports = require('./Table');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-table/lib/index.js
 ** module id = 639
 ** module chunks = 0
 **/